//////////////////////////////////////
//////////////////////////////////////
//////////////////////////////////////
// Everything to do with Changing Languages, 
// or using set language cookie to change things
//////////////////////////////////////
//////////////////////////////////////
//////////////////////////////////////

import 'jquery.scrollto';
console.log('this comes from lang-change.js');

    var $lookupLang = {
        "en": true,
        "au": true,
        "ar": true,
        "pt": true,
        "km": true,
        "es": true,
        "zh": true,
        "id": true,
        "ko": true,
        "my": true,
        "vi": true
    };

// 'use strict';
// export default function($){
//  var $cookie = $cmsj.cookie("currentLang");
    
    // Prefill/Update forms with selected Language
    // function updateDropdowns() {
    //     var $cookie = Cookies.get("currentCountry");
    // }

    // Update Url after setting new language
    ///////////////////////////////////
    function updateUrl(langVal, country) {
        var $newLang = langVal.substr(0,2),
            $urlSite = window.location.origin,
            $urlPage = window.location.pathname,
            $splitUrlPage = $urlPage.split("/");

            function ajaxPost() {
                // Send a Ajax Post request to endpoint /api/activity with body param: =
                // {Name of country selected from Dropdown}

                var data = { "body" :  country};

                $.ajax({
                        type: "POST",
                        url: "/api/activity",
                        processData: false,
                        contentType: 'application/json',
                        data: JSON.stringify(data),
                        success: function(r) {
                            console.log(">> API RESPONSE");
                            console.log(r);
                        }
                    });
            };
            
            ajaxPost();

            function replaceUrl() {
                // rebuild URL
                var $url = $urlSite + "/" + $newLang;
                
                for (var i = 2, leng = $splitUrlPage.length; i < leng; i++) {
                    $url += ("/" + $splitUrlPage[i]);
                };

            }
            function appendUrl() {
                // rebuild URL
                var $url = $urlSite + "/" + $newLang;
                
                for (var i = 1, leng = $splitUrlPage.length; i < leng; i++) {
                    $url += ("/" + $splitUrlPage[i]);
                };
            }
            function urlLookup(val) {
                if (!!$lookupLang[val]) {
                    replaceUrl();
                } else {
                    appendUrl();
                }
            }
    }

    // Language change triggered from dropdown in header
    ///////////////////////////////////
    function triggeredLangChange(langVal, msg, country){
        var $lang = langVal,
            $msg = msg,
            $country = country;

			$('.navbar-header .language-change-button.show-country-menu').removeClass("show-country-menu");
			$('#block-mainnavigation .language-change-button.show-country-menu').removeClass("show-country-menu");
			updateUrl($lang, $country);
            //$('.countrySelectorConfirm').show();
	};

	function refreshPathways(country) {
		var $pathway = "International";

		if (country === "Australia1") {
			$pathway = "Domestic";
		} else if (country === "Australia2") {
			$pathway = "AustraliaInternational";
		};
		$('.pathways-panel, .pathways-panel--accordion').each(function () {
			
            if ($(this).hasClass($pathway)) {
				$(this).addClass("show-panel");
			} else {
				$(this).removeClass("show-panel");
			}            
		});
	}

	function refreshResources(country) {
		$("[get-resources-by-country]").each(function(){
			var $this = $(this),
				$currentCountry = typeof Cookies.get("currentCountry") === "undefined" ? "Australia1" : Cookies.get("currentCountry"),
				$url = "/api/resource?parentid="+$(this).data("nodeid")+"&country=" + Cookies.get("currentCountry"),
				$html = '<div class="col-sm-6 col-xs-12 u-mbb3">' + 
							'<div class="c-downloads__title">' + 
								'<span class="g-icon-download u-c-blue"></span>' + 
								'<a target="_blank" rel="noopener noreferrer" href="[__url]">[__title]</a>' + 
							'</div>' + 
							'<div class="c-downloads__file-info u-fsi text-left">([__file], [__size])</div>' + 
						'</div>';

			$.ajax({
				url: $url,
				dataType: "json",
				success: function success(response) {             
					var $r = response,
                        $output = "";
					$(".resource-list").empty();
					if ($r.length > 0) {
						for (var $i = 0, $leng = $r.length; $i < $leng; $i++) {
							var $out = $html
                                        .replace("[__url]",String($r[$i].FileUrl))
                                        .replace("[__title]",String($r[$i].ResourceName))
                                        .replace("[__file]",String($r[$i].FileType))
                                        .replace("[__size]",String($r[$i].FileSize));
							$output += $out;
						};
						$(".resource-list").append($output);
						$($this).removeClass("hidden");
						$(".sidebar-menu [brochures-publications]").removeClass("hide");
					} else {
                        
					}
				}
			});            
		});
	}

    ///////////////////////////////////
    // Changing Language from dropdown
    $('.countrySelectorContainer')
        .on('click', '[data-lang-change]', function(){
            var $selected = $(this).attr('data-culture'),
                $msg = $(this).data('msg'),
                $country = $(this).data('value');

            // Change language
            triggeredLangChange($selected, $msg, $country);
			Cookies.set("currentCountry", $country, { expires: 365 });
			$('.countrySelector').first().val($country).trigger('change');
			$.scrollTo('#entryRequirements', { offset: -$('.mega-menu__level-1').height() - 60, duration: 800 });

			if ($(".pathways-panel").length > 0 && $("[course-comparison-table]").length == 0) {
				$.scrollTo('#pathways', { offset: -$('.mega-menu__level-1').height() - 60, duration: 800 });
				refreshPathways($country);
			}
			if($('.countrySelectorContainer-course').length < 1) {
				refreshResources($country);
			}
		});

    ///////////////////////////////////
    // Confirming language change
    $('.countrySelectorConfirm')
    .on('click', '[lang-change-confirm]', function(){
        var $lang = $('[lang-change-confirm]').attr("data-lang"),
            $country = $('[lang-change-confirm]').attr("data-country");
        Cookies.set("currentCountry", $country, { expires: 365 });
        $('.countrySelectorContainer').show();
        $('.countrySelectorConfirm').hide();
        updateUrl($lang, $country);
    });


// WEBPACK FOOTER //
// ./src/_js/partials/lang-change.js